import { render, staticRenderFns } from "./castingCallsTable.vue?vue&type=template&id=65067ab1&scoped=true&"
import script from "./castingCallsTable.vue?vue&type=script&lang=js&"
export * from "./castingCallsTable.vue?vue&type=script&lang=js&"
import style0 from "./castingCallsTable.vue?vue&type=style&index=0&id=65067ab1&scoped=true&lang=scss&"
import style1 from "./castingCallsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65067ab1",
  null
  
)

export default component.exports